import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";
import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  Sort,
  TabActionDialog,
} from "../types";

const sampleRequestSectionUrl = "/sample-requests";

export const sampleRequestListPath = sampleRequestSectionUrl;
export enum SampleRequestListUrlSortField {
  date = "date",
  customer = "customer",
}
export type SampleRequestListUrlSort = Sort<SampleRequestListUrlSortField>;
export type SampleRequestListUrlDialog = "cancel" | TabActionDialog;
export type SampleRequestListUrlQueryParams = BulkAction &
  Dialog<SampleRequestListUrlDialog> &
  SampleRequestListUrlSort &
  Pagination &
  ActiveTab;

export const sampleRequestListUrl = (params?: SampleRequestListUrlQueryParams): string => {
  const sampleRequestList = sampleRequestListPath;

  if (params === undefined) {
    return sampleRequestList;
  } else {
    return urlJoin(sampleRequestList, "?" + stringifyQs(params));
  }
};

export const sampleRequestPath = (id: string) => urlJoin(sampleRequestSectionUrl, id);
export const sampleRequestUrl = (id: string, params?: any) =>
  sampleRequestPath(encodeURIComponent(id)) + (params ? "?" + stringifyQs(params) : "");